<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup lite_options" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.common.options') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <el-tabs v-model="activeName">
                    <!-- 线程 -->
                    <el-tab-pane :label="$t('language.popup.thread')" name="thread">
                        <div class="lite_tab_content">
                            <div class="thread_item">
                                <span class="thread_item_lable">List Thread: {{ options.listThread }}</span>
                                <el-slider class="my-slider" :show-tooltip="false" v-model="options.listThread" :step="1" :min="1" :max="5" show-stops></el-slider>
                            </div>
                            <div class="thread_item">
                                <span class="thread_item_lable">Run Thread: {{ options.runThread }}</span>
                                <el-slider class="my-slider" :show-tooltip="false" v-model="options.runThread" :step="1" :min="1" :max="15" show-stops></el-slider>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 邮件通知 -->
                    <el-tab-pane :label="$t('language.popup.email')" name="email">
                        <div class="lite_tab_content">
                            <div class="email_desc">Send email notification when completing this task.</div>
                            <div>
                                <el-input size="small" class="email_input" @focus="onEmailFocus" v-model="options.email" placeholder="Email"></el-input>
                                <button class="email_test" @click="sendEmail()">{{$t('language.popup.sendMessage')}}</button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 过滤 -->
                    <el-tab-pane name="filter">
                        <span slot="label">
                            <span>{{ $t('language.popup.filter') }}</span>
                            <span class="lite_vip_icon"></span>
                        </span>
                        <div class="lite_tab_content">
                            <!-- 包含扩展名 -->
                            <div class="tag_desc">Included extensions (e.g., png, doc, mp4)</div>
                            <div class="tag_box myscroll">
                                <el-tag :key="tag" v-for="tag in options.allowedExtensions" closable :disable-transitions="false"
                                    color="#5562b430" effect="plain" type="info"
                                    @close="handleCloseIncluded(tag)">
                                    {{ tag }}
                                </el-tag>
                                <el-input class="input-new-tag" v-if="inputVisibleIncluded" v-model="inputValueIncluded"
                                    ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirmIncluded"
                                    @blur="handleInputConfirmIncluded">
                                </el-input>
                                <button v-else class="button-new-tag" size="small" @click="showInputIncluded">+ New Tag</button>
                            </div>
                            <!-- 排除文件名 -->
                            <div class="tag_desc">Exclude file names (e.g., target, dist, build)</div>
                            <div class="tag_box myscroll">
                                <el-tag :key="tag" v-for="tag in options.excludeNames" closable :disable-transitions="false"
                                    color="#5562b430" effect="plain" type="info"
                                    @close="handleCloseExclude(tag)">
                                    {{ tag }}
                                </el-tag>
                                <el-input class="input-new-tag" v-if="inputVisibleExclude" v-model="inputValueExclude"
                                    ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirmExclude"
                                    @blur="handleInputConfirmExclude">
                                </el-input>
                                <button v-else class="button-new-tag" size="small" @click="showInputExclude">+ New Tag</button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- 计划 -->
                    <el-tab-pane name="schedule">
                        <span slot="label">
                            <span>{{ $t('language.popup.cloudTransferPopup.schedule') }}</span>
                            <span class="lite_vip_icon"></span>
                        </span>
                        <div class="lite_tab_content">
                            <div class="cron_desc myscroll" v-if="showCronHelp">
                                <strong>Cron Expression Help:</strong>
                                <p>A cron expression consists of 6 fields: second, minute, hour, day, month, and weekday, separated by spaces.</p>
                                <ul>
                                    <li><strong>Second:</strong> 0-59</li>
                                    <li><strong>Minute:</strong> 0-59</li>
                                    <li><strong>Hour:</strong> 0-23</li>
                                    <li><strong>Day:</strong> 1-31</li>
                                    <li><strong>Month:</strong> 1-12 or JAN-DEC</li>
                                    <li><strong>Weekday:</strong> 0-7 or SUN-SAT (0 and 7 both mean Sunday)</li>
                                </ul>
                                <p><strong>Special characters:</strong></p>
                                <ul>
                                    <li>* Any value</li>
                                    <li>/ Step, e.g., 0/5 means every 5 units</li>
                                    <li>, List, e.g., MON,WED,FRI</li>
                                    <li>- Range, e.g., 10-15</li>
                                    <li>? Placeholder (no specific value)</li>
                                    <li>L Last, e.g., day field L means the last day of the month</li>
                                    <li>W Nearest weekday, e.g., 15W means the weekday nearest the 15th</li>
                                    <li># Nth weekday, e.g., 3#2 means the 2nd Wednesday of the month</li>
                                </ul>
                                <p><strong>Common examples:</strong></p>
                                <ul>
                                    <li>0 * * * * * → triggers at 0 second every minute</li>
                                    <li>0 0/5 * * * * → triggers every 5 minutes</li>
                                    <li>0 0 9 * * * → triggers every day at 9:00 AM</li>
                                    <li>0 0 0 1 * * → triggers at 00:00 on the 1st day of every month</li>
                                    <li>0 0 12 * * MON-FRI → triggers at 12:00 PM Monday through Friday</li>
                                </ul>
                                <p><strong>Tips:</strong> Do not set intervals shorter than 5 minutes. Cron execution respects the user's timezone. You can also validate cron expressions and check their next execution times in real-time.</p>
                            </div>
                            <div>
                                <el-input size="small" class="cron_input" v-model="options.cron" placeholder="cron expression"></el-input>
                                <el-select class="cron_select" size="small" v-model="options.cron" placeholder="Please select">
                                    <el-option v-for="item in cronDemo" :key="item.value" :label="item.name" :value="item.value"></el-option>
                                </el-select>
                                <button class="cron_help" @click="showCronHelp=!showCronHelp">Help</button>
                            </div>
                            <div class="cron_result">
                                <div v-if="cronNextExec.length > 0">
                                    <div class="cron_decode" :title="cron2Str(options.cron)">Expected execution time for the next 5 times: <b>{{ cron2Str(options.cron) }}</b></div>
                                    <ol>
                                        <li v-for="time in cronNextExec">{{ formatDate(time) }}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 底部 -->
             <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="close()" class="white">{{ $t('language.common.cancel') }}</button>
                <button @click="ok()">{{ $t('language.common.save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import cronstrue from 'cronstrue';
import 'cronstrue/locales/zh_CN';
import requestUtils from '@/js/request_util.js';
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import { Message } from "element-ui";

export default {
    props: {
        data: Object,
    },
    watch: {
        'options.cron'(val) {
            if (val) {
                this.testCron();
            } else {
                this.showCronHelp = false;
                this.cronNextExec = [];
            }
        }
    },
    data() {
        return {
            show: false,
            activeName: 'thread',
            cronNextExec: [],
            showCronHelp: false,
            cronLanguage: this.getCronLanguage(),
            cronDemo: [
                {value: '0 0/5 * * * *', name: 'Every 5 minutes'},
                {value: '0 0 0/1 * * *', name: 'Every hour'},
                {value: '0 0 9 * * *', name: 'At 09:00 AM'},
                {value: '0 0 9 * * MON', name: 'At 09:00 AM, only on Monday'},
                {value: '0 0 18 * * SUN', name: 'At 06:00 PM, only on Sunday'},
                {value: '0 0 9 1 * *', name: 'At 09:00 AM, on day 1 of the month'},
                {value: '0 0 18 L * *', name: 'At 06:00 PM, on the last day of the month'}
            ],
            options: {
                listThread: 1,
                runThread: 1,
                email: '',
                cron: '',
                excludeNames: [],
                allowedExtensions: [],
            },
            inputVisibleIncluded: false,
            inputValueIncluded: '',
            inputVisibleExclude: false,
            inputValueExclude: '',
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        getCronLanguage() {
            const lang = this.$i18n.locale;
            if (lang == 'chinese') {
                return 'zh_CN';
            } else {
                return 'en_US';
            }
        },
        cron2Str(cron) {
            if (!cron) return '';
            try {
                return cronstrue.toString(cron, { locale: this.cronLanguage });
            } catch (e) {
                return '';
            }
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            return commonUtils.i18nDateFormat(value, this.$i18n.locale);
        },
        onEmailFocus() {
            if (!this.options.email) {
                const user = commonUtils.getUser();
                this.options.email = user.email;
            }
        },
        checkEmail() {
            if (this.options.email) {
                if (!commonstate.emailpattern.test(this.options.email)) {
                    Message.warning(this.$t('language.login.enterCorrectEmai'));
                    return false;
                }
            }
            return true;
        },
        sendEmail() {
            if (this.options.email) {
                if (!this.checkEmail()) return;
                let emailData = {
                    email: this.options.email,
                    ud: commonUtils.getUser().id
                }
                this.Utils.doEmailRequest("send_test_msg", emailData).then(res => {
                    if (res.status == 200) {
                        Message.success(this.$t('language.meassage.emailSend'));
                    } else {
                        Message.error(this.$t('language.exception.' + res.reason));
                    }
                });
            }
        },
        testCron() {
            this.showCronHelp = false;
            this.cronNextExec = [];
            if (this.options.cron) {
                this.testCurCron(this.options.cron, (data) => {
                    this.cronNextExec.push(...data);
                });
            }
        },
        testCurCron(cron, callback) {
            this.sendRequest("/task/testCron", {cron: cron}, (data) => {
                if (callback) {
                    callback(data);
                }
            });
        },
        ok() {
            if (!this.checkEmail()) return;
            const user = commonUtils.getUser();
            if (!user.vip) {
                if (this.options.excludeNames.length>0 || this.options.allowedExtensions.length>0) {
                    Message.warning("Filtering is a feature for VIP users. Please upgrade and try again.");
                    return;
                }
                if (this.options.listThread>1 || this.options.runThread>2) {
                    Message.warning("For free users, the traversal thread can only be 1, and the execution threads ≤ 2.")
                    return;
                }
                if (this.options.cron) {
                    Message.warning("For free users, the cron expression is not supported.")
                    return;
                }
            }
            this.$emit('ok', this.options);
            this.show = false;
            this.activeName = 'thread';
        },
        init(type) {
            this.activeName = (type?type:'thread');
            this.showCronHelp = false;
            this.cronNextExec = [];
            var options = {};
            options.listThread = this.data.listThread;
            options.runThread = this.data.runThread;
            options.email = this.data.email;
            options.cron = this.data.cron;
            options.excludeNames = [];
            options.allowedExtensions = [];
            options.excludeNames.push(...this.data.excludeNames);
            options.allowedExtensions.push(...this.data.allowedExtensions);
            this.options = options;
        },
        close() {
            this.init();
            this.show = false;
        },
        handleCloseIncluded(tag) {
            this.options.allowedExtensions.splice(this.options.allowedExtensions.indexOf(tag), 1);
        },
        showInputIncluded() {
            this.inputVisibleIncluded = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirmIncluded() {
            let inputValueIncluded = this.inputValueIncluded;
            if (inputValueIncluded) {
                this.options.allowedExtensions.push(inputValueIncluded);
            }
            this.inputVisibleIncluded = false;
            this.inputValueIncluded = '';
        },
        handleCloseExclude(tag) {
            this.options.excludeNames.splice(this.options.excludeNames.indexOf(tag), 1);
        },
        showInputExclude() {
            this.inputVisibleExclude = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirmExclude() {
            let inputValueExclude = this.inputValueExclude;
            if (inputValueExclude) {
                this.options.excludeNames.push(inputValueExclude);
            }
            this.inputVisibleExclude = false;
            this.inputValueExclude = '';
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errCallback) {
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data);
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg);
                        if (errCallback) {
                            errCallback()
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg);
                            if (errCallback) {
                                errCallback()
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    Message.error(err);
                    if (errCallback) {
                        errCallback()
                    }
                });
        }
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box {
    width: 678px;
}

/* 弹窗内容高度 */
.lite_options .lite_popup_content {
    height: 300px;
}

/* tab内容 */
.lite_tab_content {
    padding-top: 20px;
}

/* 线程项 */
.thread_item {
    margin: 0 12px;
}

/* 文字描述 */
.cron_desc,
.cron_result,
.thread_item_lable,
.email_desc,
.tag_desc {
    font-size: 14px;
    color: #6f7886;
}

/* 所有标签 */
.tag_box {
    margin-bottom: 30px;
    height: 85px;
    overflow: auto;
}

/* 标签项 */
.tag_box .el-tag {
    margin-top: 10px;
    margin-right: 10px;
    max-width: 200px;
    padding-right: 25px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
}

.tag_box .el-tag__close {
    position: absolute;
    z-index: 1;
    right: 5px;
    top: 7px;
}

/* 新增标签按钮 */
.button-new-tag {
    margin-top: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    position: relative;
    top: 1px;
    vertical-align: middle;
}

/* 新增标签输入框 */
.input-new-tag {
    width: 90px;
    margin-bottom: 1px;
    vertical-align: middle;
}

/* 滑块样式，条形 */
.my-slider .el-slider__bar {
  background-color: #5562B4;
}

/* 滑块样式，圆形 */
.my-slider .el-slider__button {
  border-color: #5562B4;
}

.email_input {
    width: 300px;
}

.email_test {
    margin-left: 10px;
    position: relative;
    top: 1px;
}

.lite_vip_icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -1px;
    width: 20px;
    height: 20px;
    background-image: url('../../assets/images/lite/icon/vip.svg');
}

.cron_input {
    width: 230px;
}

.cron_help {
    width: calc(100% - 550px);
    margin-left: 10px;
    position: relative;
    top: 1px;
}

.cron_result {
    height: 170px;
    margin-top: 40px;
}

.cron_result li {
    margin-bottom: 10px;
}

.cron_desc {
    width: 100%;
    height: calc(100% - 90px);
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #ececec;
    overflow: auto;
    position: absolute;
    z-index: 200;
    left: 0;
    top: 90px;
}

.cron_desc li {
    margin-bottom: 5px;
}

.cron_desc p {
    line-height: 20px;
}

.cron_select {
    width: 290px;
    margin-left: 10px;
}

.cron_decode {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_options.vue